import React from 'react';
import { Card, Grid, Button } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { forgotPassword } from 'app/redux/actions/AuthActions';

const ForgotPassword = () => {
  const [form, setForm] = React.useState({ mobile: '' });
  const formRef = React.useRef();
  const dispatch = useDispatch();

  const handleChange = (event) => {
    event.persist();
    setForm({
      ...form,
      [event.target.name]: event.target.value
    });
  };
  const handleFormSubmit = () => {
    dispatch(forgotPassword(form));
    // resetPassword({ ...form });
  };

  return (
    <div className="signup flex justify-center w-full h-full-screen">
      <div className="p-8">
        <Card className="signup-card position-relative y-center">
          <Grid container>
            <Grid item lg={5} md={5} sm={5} xs={12}>
              <div className="p-8 flex justify-center items-center h-full">
                <img src="/assets/images/illustrations/dreamer.svg" alt="" />
              </div>
            </Grid>
            <Grid item lg={7} md={7} sm={7} xs={12}>
              <div className="p-9 h-full bg-light-gray position-relative">
                <ValidatorForm ref={formRef} onSubmit={handleFormSubmit}>
                  <TextValidator
                    className="mb-6 w-full"
                    variant="outlined"
                    label="Mobile Number"
                    onChange={handleChange}
                    type="text"
                    name="mobile"
                    value={form.mobile}
                    validators={['required']}
                    errorMessages={['this field is required']}
                  />
                  <div className="flex items-center">
                    <Button variant="contained" color="primary" type="submit">
                      Reset Password
                    </Button>
                    <span className="ml-4 mr-2">or</span>
                    <Button
                      className="capitalize"
                      component={RouterLink}
                      to="/session/signin"
                    >
                      Sign in
                    </Button>
                  </div>
                </ValidatorForm>
              </div>
            </Grid>
          </Grid>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
